// Module
var code = "<div class=\"designer-package-view\">\n  <div class=\"designer-package-view-wrapper\">\n    <json-explorer [data]=\"packageJson\" [collapsed]=\"collapsed\"></json-explorer>\n  </div>\n</div>\n";
// Exports
module.exports = code;